var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fromConstructor } from "./component-type";
import { RenderPerformanceMeasure } from "./render-performance-hooks";
import { FEATURE_FLAGS } from "@agentx/agentx-services";
/**
 As this has to be the first thing that takes places in the application, before any UI is instantiated, the feature
 flag must be picked up from localStorage. As a result, setting the feature flag will require 2 restarts to take effect -
 the first time, the value will be stored, allowing it to be picked up the second time.
 */
export function observePerformance() {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const isObservePerformanceEnabled = JSON.parse((_a = localStorage.getItem(FEATURE_FLAGS.OBSERVE_PERFORMANCE_ENABLED)) !== null && _a !== void 0 ? _a : "false");
        if (!isObservePerformanceEnabled) {
            return;
        }
        const originalDefine = customElements.define;
        try {
            customElements.define = function (name, customElementConstructor, options) {
                try {
                    const renderPerformanceMeasure = new RenderPerformanceMeasure(fromConstructor(customElementConstructor));
                    renderPerformanceMeasure.measurePerformance(name, customElementConstructor);
                }
                finally {
                    originalDefine.call(this, name, customElementConstructor, options);
                }
            };
        }
        catch (_b) {
            customElements.define = originalDefine;
        }
    });
}
